module.exports = __webpack_public_path__ + "static/media/iphone-x-outdoor-bench-generating-setlist-dark-resized.76f09b0b.jp2";